import gql from 'graphql-tag';

export const GET_LENDER_APPROVAL_TERMS_SUMMARY = gql`
  query LenderApprovalTermsSummary($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      approvalTermsSummary(input: $input) {
        success
        error
        entity {
          approvedRate {
            min
            max
            avg
          }
          approvedTerm {
            min
            max
            avg
          }
          docFee {
            min
            max
            avg
          }
        }
      }
    }
  }
`;
